import { render, staticRenderFns } from "./ProductPage1.vue?vue&type=template&id=e11a8278&scoped=true"
import script from "./ProductPage1.vue?vue&type=script&lang=js"
export * from "./ProductPage1.vue?vue&type=script&lang=js"
import style0 from "./ProductPage1.vue?vue&type=style&index=0&id=e11a8278&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e11a8278",
  null
  
)

export default component.exports